import VDialogPW from '@voly/ui-components/src/v2/VDialogPW';
import VFormField from '@voly/ui-components/src/v2/VFormField.jsx';
import VInput from '@voly/ui-components/src/v2/VInput.jsx';
import { useRef, useState } from 'react';
import { translate } from 'src/app/project/features/translate/translate';

interface NewCustomFieldGroupModalProps {
  open: boolean;
  onClose: () => void;
  onCreate: (name: string) => void;
}

const NewCustomFieldGroupModal = ({ open, onClose, onCreate }: NewCustomFieldGroupModalProps) => {
  const [groupName, setGroupName] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const isEmpty = groupName.trim() === '';
  const errorText = isTouched && isEmpty ? translate('group_name_required') : undefined;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setIsTouched(true);
    setGroupName(event.target.value);
  };

  const resetForm = (): void => {
    setGroupName('');
    setIsTouched(false);
  };

  const handleClose = (): void => {
    resetForm();
    onClose();
  };

  const handleOpenChange = (details: { open: boolean }): void => {
    if (!details.open) {
      handleClose();
    }
  };

  const handleOk = (): void => {
    if (isEmpty) {
      setIsTouched(true);
      inputRef.current?.focus();
      return;
    }
    onCreate(groupName.trim());
    resetForm();
  };

  return (
    <VDialogPW
      open={open}
      onOpenChange={handleOpenChange}
      onOk={handleOk}
      onCancel={handleClose}
      loading={false}
      title={translate('create_group')}
      body={
        <VFormField
          label={translate('group_name')}
          helperText=""
          errorText={errorText}
          invalid={Boolean(errorText)}
        >
          <VInput
            ref={inputRef}
            placeholder={translate('group_name_placeholder')}
            value={groupName}
            onChange={handleChange}
          />
        </VFormField>
      }
      saveBtnText={translate('create_group')}
    />
  );
};

export default NewCustomFieldGroupModal;
